import React from 'react';
import { TrackedObject } from '../services/ObjectsService';

export interface ObjectListProps {
  objects: TrackedObject[];
  onEdit: (obj: TrackedObject) => void;
  onDelete: (obj: TrackedObject) => void;
  onReAuth: (obj: TrackedObject) => void;
  onRefresh: (obj: TrackedObject) => void;
  refreshingIds: Set<string>;
}

function formatTimestamp(epoch: number): string {
  return new Date(epoch).toLocaleString();
}

const ObjectList: React.FC<ObjectListProps> = ({ objects, onEdit, onDelete, onReAuth, onRefresh, refreshingIds }) => {
  if (objects.length === 0) {
    return <p className="empty-state">No objects have been created yet.</p>;
  }

  return (
    <table className="object-list-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Description</th>
          <th>Type</th>
          <th>Last Updated</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {objects.map((obj) => (
          <tr key={obj.id}>
            <td>{obj.name}</td>
            <td>{obj.description ?? ''}</td>
            <td>{obj.type ?? ''}</td>
            <td>{formatTimestamp(obj.updatedAt)}</td>
            <td>
              <button
                className="btn-primary"
                onClick={() => onRefresh(obj)}
                disabled={refreshingIds.has(obj.id)}
              >
                {refreshingIds.has(obj.id) ? (
                  <span className="spinner" aria-label="Refreshing">⟳</span>
                ) : (
                  'Refresh'
                )}
              </button>
              <button className="btn-secondary" onClick={() => onEdit(obj)}>
                Edit
              </button>
              <button className="btn-warning" onClick={() => onReAuth(obj)}>
                Re-Auth
              </button>
              <button className="btn-danger" onClick={() => onDelete(obj)}>
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ObjectList;
